import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PaginationComponent } from './pagination.component';
import { NumberCollectionPipe } from '../pipe/number-collection.pipe';
import { AppRoutingModule } from '../app.routes';
import { DateFormatPipe } from '../pipe/date-format.pipe';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule,  AppRoutingModule],
    declarations: [PaginationComponent, NumberCollectionPipe, DateFormatPipe],
    exports : [PaginationComponent, NumberCollectionPipe, DateFormatPipe]
})
export class CommonModule {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/common.module.ts